import { Tooltip } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { Switcher } from 'components/atoms/switcher';
import { TooltipForHeader } from 'components/organisms/projects-report/common';
import { useActiveProjectTemplate } from 'data/templates/projects';

const Views = [
  {
    id: 'list',
    path: '/spaces',
    key: 'list_view',
  },
  {
    id: 'dynamic',
    path: '/spaces/dynamic',
    key: 'dynamic_view',
    tooltip: (
      <TooltipForHeader
        title={<FormattedMessage id="templates.dynamic.label" />}
        description={<FormattedMessage id="templates.dynamic.tab.tooltip" />}
      />
    ),
  },
];

const StyledTooltip = styled(Tooltip)`
  display: flex;
  align-items: center;
`;

export const ViewGroup: FC = () => {
  const template = useActiveProjectTemplate();

  const { pathname } = useLocation();

  const isDynamic = pathname.includes('dynamic');

  return (
    <Switcher value={isDynamic ? 'dynamic' : 'list'} activeColor="black">
      {Views.map(({ id, key, path, tooltip }) => (
        <Link to={`/templates/projects/${template.templateId || 'new'}${path}`}>
          <Switcher.Button value={id} key={id}>
            <StyledTooltip placement="rightTop" title={tooltip}>
              <FormattedMessage id={key} />
            </StyledTooltip>
          </Switcher.Button>
        </Link>
      ))}
    </Switcher>
  );
};
